// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Rky8g","cardIcon":"styles_cardIcon__DK_7F","cardTitle":"styles_cardTitle__QPz6i","cardBody":"styles_cardBody__t26HH"};